import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import PrimeTable from '../../../components/PrimeTable'
import { useState, useContext, useCallback } from 'react'
import { PropostaContext } from './index'
import ModalDadosCadastrais from './ModalDadosCadastrais'
import { metodoPrograma } from '../../../components/api'
import { FolderSharedOutlined } from '@mui/icons-material'
import { LuEye, LuX } from 'react-icons/lu'
import dayjs from 'dayjs'
import { useModal } from '../../../components/Utils/UseModal'
import ModalDocumento from './ModalDocumento'
import FileUploader from '../../../components/FileUploader'
import { FaPrint } from 'react-icons/fa'

const returnSexo = (sexo) => {
  switch (sexo) {
    case 'M':
      return 'Masculino'
    case 'F':
      return 'Feminino'
    case 'B':
      return 'Não binário'
    case 'N':
      return 'Não declarou'
    default:
      return ''
  }
}

function formatPhone(value) {
  const cleanedValue = value.replace(/\D/g, '')

  const formattedValue = cleanedValue.replace(
    /(\d{2})(\d{5})(\d{4})/,
    '($1) $2-$3',
  )

  return formattedValue
}

const Paciente = () => {
  const { dadosEdicao, dispatch, formatCPF } = useContext(PropostaContext)
  const openModal = useModal(ModalDocumento)
  const [dsDocumento, setDsDocumento] = useState('')
  const [refresh, setRefresh] = useState(true)
  const [novoDocumento, setNovoDocumento] = useState(false)

  const [dsTermo, setDsTermo] = useState('')
  const [dsReac, setDsReac] = useState('')
  const [dsBem, setDsBem] = useState('')
  const [dsDetox, setDsDetox] = useState('')
  const [dsAcompanhante, setDsAcompanhante] = useState('')

  const [modalDocumentos, setModalDocumentos] = useState({
    open: false,
    paciente: null,
  })

  const [modalRelatorio, setModalRelatorio] = useState({
    open: false,
    paciente: null,
  })

  const abrirModalDocumentos = (paciente) => {
    setModalDocumentos({
      open: true,
      paciente,
    })
  }

  const fecharModalDocumentos = () => {
    setDsDocumento('')
    setNovoDocumento(false)

    setModalDocumentos({
      open: false,
      paciente: null,
    })
  }

  const abrirModalRelatorio = (paciente) => {
    setDsTermo(paciente[26])
    setDsReac(paciente[27])
    setDsBem(paciente[28])
    setDsDetox(paciente[29])
    setDsAcompanhante(paciente[30])

    setModalRelatorio({
      open: true,
      paciente,
    })
  }

  const fecharModalRelatorio = () => {
    setDsTermo('')
    setDsReac('')
    setDsBem('')
    setDsDetox('')
    setDsAcompanhante('')
    setModalRelatorio({
      open: false,
      paciente: null,
    })
  }

  const [openModalDadosCadastrais, setOpenModalDadosCadastrais] =
    useState(false)
  const [data, setData] = useState(true)

  const handleClick = async (value) => {
    setData({
      dados: value,
      idAtendimento: dadosEdicao.idAtendimento,
    })
    setOpenModalDadosCadastrais(true)
  }

  const addPaciente = async () => {
    setData({
      dados: [],
      idAtendimento: dadosEdicao.idAtendimento,
    })
    setOpenModalDadosCadastrais(true)
  }

  const exclui = useCallback(
    (dados) => {
      metodoPrograma('excluiPacienteAtendimento', {
        idAtendimento: dadosEdicao.idAtendimento,
        idPaciente: dados[0],
      }).then((res) => {
        if (res.status) {
          setRefresh((prev) => prev + 1)
        }
      })
    },
    [dadosEdicao.idAtendimento],
  )

  const salvaInformacoesRelatorio = useCallback(
    (dados) => {
      metodoPrograma('salvaInformacoesRelatorio', {
        idPaciente: dados[0],
        idAtendimento: dadosEdicao?.idAtendimento,
        dsTermo,
        dsReac,
        dsBem,
        dsDetox,
        dsAcompanhante,
      }).then((res) => {
        if (res.status) {
          setRefresh((prev) => prev + 1)
          fecharModalRelatorio()
        }
      })
    },
    [dsTermo, dsReac, dsBem, dsDetox, dsAcompanhante, dadosEdicao],
  )

  const excluiDocumentoPaciente = useCallback((dados) => {
    metodoPrograma('deletaDocumentoPaciente', {
      idLaudo: dados[0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const abrirArquivo = async (linhaOriginal) => {
    await openModal({
      nmDocumento: linhaOriginal?.[1],
      token: linhaOriginal?.[4],
    })
  }

  const salvaDocumento = async (v) => {
    const documento = v?.documento[0]

    const payload = {
      idDocumento: documento?.idDocumento,
      dsDocumento,
      idAtendimento: dadosEdicao?.idAtendimento,
      idPaciente: modalDocumentos?.paciente?.[0],
    }

    await metodoPrograma('salvaDocumentoPaciente', payload)

    setDsDocumento('')
    setNovoDocumento(false)

    setRefresh((v) => !v)
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="h5">Dependentes</Typography>
          <Divider />
        </Grid>

        <Dialog
          open={modalRelatorio.open}
          onClose={fecharModalRelatorio}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pr: 1,
            }}
          >
            <Typography variant="h6">
              Informações para Relatório de {modalRelatorio?.paciente?.[1]}
            </Typography>

            <Tooltip title="Fechar">
              <IconButton onClick={fecharModalRelatorio} size="small">
                <LuX size={20} />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent dividers>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                mb: 3,
                borderRadius: 2,
                bgcolor: 'grey.50',
              }}
            >
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Informações para o Relatório Clínico
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Informe os dados abaixo. Essas informações serão utilizadas na
                geração do
                <strong> Relatório da Ficha do Cliente</strong>, destinado ao
                <strong> Diretor Médico</strong>.
              </Typography>
            </Paper>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  label="Termografia"
                  value={dsTermo}
                  onChange={(e) => setDsTermo(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  label="REAC"
                  value={dsReac}
                  onChange={(e) => setDsReac(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  label="BEM"
                  value={dsBem}
                  onChange={(e) => setDsBem(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  label="DETOX"
                  value={dsDetox}
                  onChange={(e) => setDsDetox(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  label="Acompanhante"
                  value={dsAcompanhante}
                  onChange={(e) => setDsAcompanhante(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" onClick={fecharModalRelatorio}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              onClick={() => salvaInformacoesRelatorio(modalRelatorio.paciente)}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={modalDocumentos.open}
          onClose={fecharModalDocumentos}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pr: 1,
            }}
          >
            <Typography variant="h6">
              Exames de {modalDocumentos?.paciente?.[1]}
            </Typography>

            <Tooltip title="Fechar">
              <IconButton onClick={fecharModalDocumentos} size="small">
                <LuX size={20} />
              </IconButton>
            </Tooltip>
          </DialogTitle>

          <DialogContent dividers>
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Grid item>
                {!novoDocumento && (
                  <Button
                    variant="contained"
                    onClick={() => setNovoDocumento(true)}
                  >
                    Novo Documento
                  </Button>
                )}
              </Grid>
            </Grid>

            {novoDocumento && (
              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{
                  mb: 3,
                  p: 2,
                  border: '1px solid #ddd',
                  borderRadius: 1,
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">
                    Informe um título que facilite a identificação do documento.
                    Sempre que possível, inclua o nome do exame e/ou a data em
                    que ele foi realizado.
                    <strong> Exemplo:</strong>{' '}
                    <i>Hemograma Completo - 15/07/2026</i> ou{' '}
                    <i>Ressonância Magnética - Coluna Lombar - 20/06/2026</i>.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                  <TextField
                    fullWidth
                    required
                    size="small"
                    label="Título do documento"
                    placeholder="Ex.: Hemograma Completo - 15/07/2026"
                    value={dsDocumento}
                    onChange={(e) => setDsDocumento(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FileUploader
                    key={novoDocumento}
                    disabled={!dsDocumento.trim()}
                    path="/proposta/"
                    fullWidth
                    snPublico="N"
                    onUploadComplete={salvaDocumento}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Button
                    color="inherit"
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setNovoDocumento(false)
                      setDsDocumento('')
                    }}
                  >
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            )}
            {!novoDocumento && (
              <PrimeTable
                codigo="CtrlProposta"
                action="listaDocumentoPaciente"
                rows={10}
                parametros={{
                  idAtendimento: dadosEdicao?.idAtendimento,
                  idPaciente: modalDocumentos?.paciente?.[0],
                }}
                head={['Título', 'Arquivo', 'Usuário', 'Data', 'Ações']}
                line={(item) => [
                  item?.[7],
                  item?.[1],
                  item?.[3]?.[1],
                  item?.[6] ? dayjs(item?.[6]).format('DD/MM/YYYY HH:mm') : '',
                  '',
                ]}
                refresh={refresh}
                onDelete={
                  dadosEdicao.tpSituacao === '0'
                    ? { action: excluiDocumentoPaciente }
                    : undefined
                }
                collumnsDateHour={[4]}
                columnOptions={[
                  {
                    alias: 4,
                    customJsx: ({ linhaOriginal }) => (
                      <IconButton
                        onClick={() => abrirArquivo(linhaOriginal)}
                        size="small"
                      >
                        <LuEye />
                      </IconButton>
                    ),
                  },
                ]}
              />
            )}
          </DialogContent>
        </Dialog>

        {dadosEdicao.idAtendimento && (
          <Grid item xs={12}>
            <ModalDadosCadastrais
              data={data}
              openModalDadosCadastrais={openModalDadosCadastrais}
              setRefresh={setRefresh}
              setOpenModalDadosCadastrais={setOpenModalDadosCadastrais}
            />

            <Grid container justifyContent="flex-end">
              <Button variant="contained" color="primary" onClick={addPaciente}>
                Novo Dependente
              </Button>
            </Grid>

            <PrimeTable
              action="listaPaciente"
              codigo="CtrlProposta"
              parametros={{ idAtendimento: dadosEdicao.idAtendimento }}
              autocompleteEditableIndex={[0]}
              actionResponse={(resp) =>
                dispatch({
                  type: 'dadosEdicao',
                  field: 'listPacientes',
                  value: resp?.lista || [],
                })
              }
              refresh={refresh}
              head={[
                'Paciente',
                'CPF',
                'Data Nascimento',
                'Sexo',
                'Telefone',
                'E-mail',
                'Relatório',
                'Exames',
              ]}
              line={(item) => [
                item[1],
                item[2] ? formatCPF(item[2]) : null,
                item[4],
                returnSexo(item[5]),
                item[6] ? formatPhone(item[6]) : null,
                item[7],
                <Tooltip key={item[0]} title="Informações para Relatório">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation() // evita selecionar a linha
                      abrirModalRelatorio(item)
                    }}
                  >
                    <FaPrint fontSize="small" />
                  </IconButton>
                </Tooltip>,
                <Tooltip key={item[0]} title="Documentos do paciente">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation() // evita selecionar a linha
                      abrirModalDocumentos(item)
                    }}
                  >
                    <FolderSharedOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>,
              ]}
              collumnsDate={[2]}
              rows={100000}
              disablePagination
              onRowSelect={handleClick}
              onDelete={{ index: 20, action: exclui }}
            />
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default Paciente
